import { Component, HostListener, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
import { ApiEndPoint } from 'src/app/config/api-end-point';
@Component({
    selector: 'app-search-product',
    templateUrl: './search-product.component.html',
    styleUrls: ['./search-product.component.scss'],
    standalone: false
})
export class SearchProductComponent implements OnInit {
  @HostListener('window:scroll', ['$event'])
  loadAtFist: boolean = false;

  activeButton = 'product_wholesale'

  panelOpenState = false;

  categoryListArray: any = [];
  itemPerPage = 50;
  currentPage = 1;
  totalItems: any;
  categoryId: any;
  images: any;
  subCategoryListArray: any = [];
  productBySubCategoryArray: any = [];
  subCategoryId: any;
  selectedSubCategoryId: any;
  selectedCategoryId: any;


  // parentElement: any;
  // classList: any;





  _id: any



  productIds:any
  searchQuery: string = '';
  serviceName: any; // Same variable name as customer-category-list
  loggedInUserType: any;
  latitude: any;
  longitude: any;
  user: any;
  isLoggedIn: any;
  isLoading: boolean = false;
  imageLinks: any; // For service search results

  // Global breadcrumb configuration (shared component)
  headingName: any = 'Search Product';
  linkerRouteItems: any = [
    { name: 'Home', route: '/home' },
    { name: 'Search Product', route: '/search-product' }
  ];

  // Image carousel state
  private carouselIndexMap: { [productId: string]: number } = {};
  private carouselTimerMap: { [productId: string]: any } = {};

  // Filter state
  allProducts: any[] = [];
  selectedFilterCategoryId: string | null = null;
  priceMin = 0;
  // Match homepage-style price banding: 0 – 10,000+
  priceMax = 10000;
  selectedMaxPrice = this.priceMax;
  discountOptions = [
    { value: 10, label: '10% and above' },
    { value: 20, label: '20% and above' },
    { value: 30, label: '30% and above' },
    { value: 40, label: '40% and above' },
    { value: 50, label: '50% and above' },
    { value: 60, label: '60% and above' },
    { value: 70, label: '70% and above' },
    { value: 80, label: '80% and above' },
    { value: 90, label: '90% and above' },
  ];
  selectedMinDiscount: number | null = null;

  constructor(private activatedroute: ActivatedRoute, private _formBuilder: UntypedFormBuilder, private router: Router, public commonService: CommonService) {
    this.activatedroute.queryParams.subscribe((res: any) => {
      this._id = res._id;
    })
    
    // Always subscribe to search events from header
    this.commonService.invokeFirstComponentFunction.subscribe((res) => {
      // Reload the search query from localStorage every time
      this.searchQuery = localStorage.getItem('searchQuery') || '';
      this.serviceName = this.searchQuery;
      
      console.log('Search event received. Query:', this.searchQuery);
      
      if (this.searchQuery && this.searchQuery.trim()) {
        // Reset to first page for new search
        this.currentPage = 1;
        // Trigger product search - search for products matching the keyword
        this.searchProductByName();
      } else {
        this.resetToDefaultState();
      }
    });

  }

  // ===========================

  ngOnInit(): void {
    window.scrollTo(0, 0);
    
    // Get user info - exactly like customer-category-list
    this.loggedInUserType = localStorage.getItem('userType');
    this.isLoggedIn = localStorage.getItem('token') ? true : false;
    
    // Get geolocation - exactly like customer-category-list
    navigator.geolocation.getCurrentPosition(
      function (position) {},
      function () {}
    );
    this.getPosition().then((pos) => {
      localStorage.setItem('location', JSON.stringify(pos));
    });
    this.getLocation();
    
    // Check if there's a search query from the header
    const routeSearch = this.activatedroute.snapshot.queryParams.search;
    this.searchQuery = routeSearch || localStorage.getItem('searchQuery') || '';
    this.serviceName = this.searchQuery;
    
    // Always load categories for sidebar
    this.getCategoryLists();
    // Load banner only when no search query
    if (!this.serviceName || !this.serviceName.trim()) {
      this.getBannerProductList();
    }
  }

  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (position) {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            
            // Load products based on search query
            if (this.serviceName && this.serviceName.trim()) {
              this.searchProductByName();
            } else {
              this.getAllProducts();
            }
          }
        },
        (error) => {
          console.log(error);
          // Still try to load products even without location
          if (this.serviceName && this.serviceName.trim()) {
            this.searchProductByName();
          } else {
            this.getAllProducts();
          }
        }
      );
    } else {
      // Still try to load products even without location
      if (this.serviceName && this.serviceName.trim()) {
        this.searchProductByName();
      } else {
        this.getAllProducts();
      }
    }
  }

  showActivebutton(title: any) {
    this.activeButton = title
  }

  tab:any
  select(tab:any){
   this.tab = tab
  }
  categoryListArrayNew: any

  datalist:any
  // -------------------- get category list --------------------- //
  // -------------------- get category list --------------------- //
  getCategoryList() {
    let apiReqUrl: any = `product/productOfOwn`
    this.commonService.showSpinner();
    let apiReqData: any = {
      page: String(this.currentPage),
      limit: String(this.itemPerPage),

    }
    // remove empty keys from request body
    apiReqData = this.commonService.removeEmptyKey(apiReqData)
    this.commonService.postApi(apiReqUrl, apiReqData, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        const docs = res.result.docs ? res.result.docs : [];
        this.allProducts = [...docs];
        this.applyFilters(false);
        this.datalist = docs[0]?.thumbnail;
        // Use backend total count for pagination
        this.totalItems = res.result.total || res.result.count || docs.length;
        // this.commonService.successToast(res['responseMessage'])
        this.commonService.hideSpinner();
        // this.commonService.successToast(res.responseMessage);

      } else {
        this.categoryListArrayNew = []
        this.totalItems = 0
        this.commonService.hideSpinner();
        // this.commonService.errorToast(res.responseMessage)
      }
    }, (err: any) => {
      if (err.responseCode == 404) {
        this.categoryListArrayNew = []
        this.totalItems = 0
        // this.commonService.errorToast(err.responseMessage);

      }else{
      this.router.navigate(['/login'])

      }
    }  )
  }
  searchCategory(id:any) {
    // Clear search query when filtering by category
    this.searchQuery = '';
    localStorage.removeItem('searchQuery');
    // remember selection and reset page
    this.selectedCategoryId = id;
    this.currentPage = 1;
    
    let apiReqUrl: any = `product/listProductBySortion`
    this.commonService.showSpinner();
    let apiReqData: any = {
      page: String(this.currentPage),
      limit: String(this.itemPerPage),
      userType: 'RETAILER',
      lng: this.longitude || 0,
      lat: this.latitude || 0,
      categoryId: [id]

    }
    // remove empty keys from request body
    apiReqData = this.commonService.removeEmptyKey(apiReqData)
    const a = this.commonService.isLoggedIn() ? 1 : 0
    this.commonService.postApi(apiReqUrl, apiReqData, a).subscribe((res: any) => {
      
      if (res.responseCode == 200) {
        const docs = res.result.docs ? res.result.docs : [];
        this.allProducts = [...docs];
        this.applyFilters(false);
        if (docs.length > 0 && docs[0]?.thumbnail) {
          this.datalist = docs[0].thumbnail;
        }
        this.totalItems = res.result.count || res.result.total || docs.length;
        
        
        
        // thumbnail

        // this.commonService.successToast(res['responseMessage'])
        this.commonService.hideSpinner();
        // this.commonService.successToast(res.responseMessage);

      } else {
        this.categoryListArrayNew = []
        this.totalItems = 0
        this.commonService.hideSpinner();
        // this.commonService.errorToast(res.responseMessage)
      }
    }, (err: any) => {
      if (err.responseCode == 404) {
        this.categoryListArrayNew = []
        this.totalItems = 0
        // this.router.navigate(['/login'])
        // this.commonService.errorToast(err.responseMessage);

      }else{
        this.router.navigate(['/login'])
      }
    }  )
  }

  // Search services by name/keyword - EXACT same logic as customer-service-list
  searchServiceByName() {
    // Use the same API as customer-service-list
    let apiReqUrl: any = `service/listCategoryService`
    let apiReqData = {
      search: this.serviceName,
      page: this.currentPage,
      limit: this.itemPerPage,
    }

    this.commonService.removeEmptyKey(apiReqData)
    let a = this.commonService.isLoggedIn() ? 1 : 0
    
    this.commonService.postApi(apiReqUrl, apiReqData, a).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.allProducts = res.result.docs || [];
        this.applyFilters(false);
        if (!this.allProducts.length) {
          this.isLoading = true;
        } else {
          this.isLoading = false;
        }
        this.totalItems = res.result.total || this.allProducts.length;
        this.imageLinks = res["result"]["thumbnail"];
        this.commonService.hideSpinner();
      } else {
        this.isLoading = true;
        this.categoryListArrayNew = []
        this.totalItems = 0;
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage)
      }
    }, (err) => {
      this.isLoading = true;
      this.categoryListArrayNew = []
      this.totalItems = 0;
      this.commonService.hideSpinner();
    })
  }

  // Search products by name/keyword - EXACT same logic as customer-category-list
  searchProductByName() {
    // Use serviceName like customer-category-list
    let apiReqUrl: any = `product/listProductBySortion`;
    let apiReqData = {
      search: this.serviceName,
      page: String(this.currentPage),
      limit: String(this.itemPerPage),
      userType: 'RETAILER',
      lng: this.longitude || 0,
      lat: this.latitude || 0,
    };
    
    this.commonService.removeEmptyKey(apiReqData);
    
    if (this.isLoggedIn) {
      // Logged in - use authenticated endpoint
      this.commonService.postApi(apiReqUrl, apiReqData, 1).subscribe(
        (res: any) => {
          if (res.responseCode == 200) {
            this.allProducts = res.result.docs || [];
            this.applyFilters(false);
            if (!this.allProducts.length) {
              this.isLoading = true;
            } else {
              this.isLoading = false;
            }
            this.totalItems = res.result.count || res.result.total || this.allProducts.length;
            if (this.allProducts.length > 0 && this.allProducts[0]?.thumbnail) {
              this.datalist = this.allProducts[0].thumbnail;
            }
            this.commonService.hideSpinner();
          } else {
            this.isLoading = true;
            this.categoryListArrayNew = [];
            this.totalItems = 0;
            this.commonService.hideSpinner();
          }
        },
        (err) => {
          this.isLoading = true;
          this.categoryListArrayNew = [];
          this.totalItems = 0;
          this.commonService.hideSpinner();
        }
      );
    } else {
      // Not logged in - use public endpoint
      this.commonService.postApi(apiReqUrl, apiReqData, 0).subscribe(
        (res: any) => {
          if (res.responseCode == 200) {
            this.allProducts = res.result.docs || [];
            this.applyFilters(false);
            if (!this.allProducts.length) {
              this.isLoading = true;
            } else {
              this.isLoading = false;
            }
            this.totalItems = res.result.count || res.result.total || this.allProducts.length;
            if (this.allProducts.length > 0 && this.allProducts[0]?.thumbnail) {
              this.datalist = this.allProducts[0].thumbnail;
            }
            this.commonService.hideSpinner();
          } else {
            this.isLoading = true;
            this.categoryListArrayNew = [];
            this.totalItems = 0;
            this.commonService.hideSpinner();
          }
        },
        (err) => {
          this.isLoading = true;
          this.categoryListArrayNew = [];
          this.totalItems = 0;
          this.commonService.hideSpinner();
        }
      );
    }
  }

  searchCategorybyHome() {
    this.productIds = [localStorage.getItem('category')];
    let apiReqUrl: any = `product/productOfOwn`
    this.commonService.showSpinner();
    let apiReqData: any = {
      page: String(this.currentPage),
      limit: String(this.itemPerPage),
      categoryId: this.productIds

    }
    // remove empty keys from request body
    apiReqData = this.commonService.removeEmptyKey(apiReqData)
    this.commonService.postApi(apiReqUrl, apiReqData, 1).subscribe((res: any) => {
      
      if (res.responseCode == 200) {
        const docs = res.result.docs ? res.result.docs : [];
        this.allProducts = [...docs];
        this.applyFilters(false);
        this.datalist = docs[0]?.thumbnail;
        this.totalItems = res.result.total || res.result.count || docs.length;
        
        
        
        // thumbnail

        // this.commonService.successToast(res['responseMessage'])
        this.commonService.hideSpinner();
        // this.commonService.successToast(res.responseMessage);

      } else {
        this.categoryListArrayNew = []
        this.totalItems = 0
        this.commonService.hideSpinner();
        // this.router.navigate(['/login'])
        // this.commonService.errorToast(res.responseMessage)
      }
    }, (err: any) => {
      if (err.responseCode == 404) {
        this.categoryListArrayNew = []
        this.totalItems = 0
        // this.router.navigate(['/login'])

        // this.commonService.errorToast(err.responseMessage);

      }else{
      this.router.navigate(['/login'])

      }
    }  )
  }



  pagination(event: number) {
    this.currentPage = event;
    // If there's a search query, use product search
    if (this.serviceName && this.serviceName.trim()) {
      this.searchProductByName();
    } else if (this.selectedCategoryId) {
      this.searchCategory(this.selectedCategoryId);
    } else if (this.selectedSubCategoryId) {
      // Keep paginating within selected subcategory
      const id = this.selectedSubCategoryId;
      const apiReqUrl = `product/listProductBySortion`;
      const apiReqData: any = {
        page: String(this.currentPage),
        limit: String(this.itemPerPage),
        userType: 'RETAILER',
        lng: this.longitude || 0,
        lat: this.latitude || 0,
        subCategoryId: [id]
      };
      const cleaned = this.commonService.removeEmptyKey(apiReqData);
      const a = this.commonService.isLoggedIn() ? 1 : 0;
      this.commonService.postApi(apiReqUrl, cleaned, a).subscribe((res: any) => {
        if (res.responseCode == 200) {
          this.categoryListArrayNew = res.result.docs ? res.result.docs : [];
          this.totalItems = res.result.count || res.result.total || 0;
          this.commonService.hideSpinner();
        } else {
          this.categoryListArrayNew = [];
          this.totalItems = 0;
          this.commonService.hideSpinner();
        }
      }, () => {
        this.categoryListArrayNew = [];
        this.totalItems = 0;
        this.commonService.hideSpinner();
      })
    } else {
      // Otherwise load all products
      this.getAllProducts();
    }
  }

  // Pagination helpers (same behavior as customer-product-list)
  goToPage(page: number) {
    const totalPages = this.getTotalPages();
    if (page < 1 || page > totalPages) return;
    this.pagination(page);
  }

  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    const pages: number[] = [];
    const maxVisiblePages = 5;
    if (totalPages <= 0) return pages;
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }
    const start = Math.max(1, this.currentPage - 2);
    const end = Math.min(totalPages, start + maxVisiblePages - 1);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  }

  getTotalPages(): number {
    return Math.ceil((this.totalItems || 0) / (this.itemPerPage || 1));
  }










  // ===========================================================================      ================================





  getCategoryLists() {
    let apiReqUrl: any = `admin/listCategory`
    // this.commonService.showSpinner();
    let apiReqData: any = {
      // page: String(this.currentPage),
      // limit: String(this.itemPerPage)
    }
    // remove empty keys from request body
    // apiReqData = this.commonService['removeEmptyKey'](apiReqData)
    apiReqData = this.commonService.removeEmptyKey(apiReqData)

    this.commonService.postApi(apiReqUrl, apiReqData, 1).subscribe((res: any) => {
      
      if (res.responseCode == 200) {
        this.categoryListArray = res.result.docs ? res.result.docs : '';
        

        this.totalItems = res.result.total
        this.commonService.hideSpinner();
        // this.commonService.successToast(res.responseMessage);
      } else {
        this.categoryListArray = []
        this.totalItems = 0
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage)
      }
    })
  }

  getCategoryId(id: any) {
    this.categoryId = id.target.value
    
  }



  getSubCategoryList(id: any) {
    let apiReqUrl = `${'admin/subcategoryListWithCategory' + '?categoryId=' + id}`
    // this.commonService.showSpinner();

    // remove empty keys from request body
    this.commonService.getApi(apiReqUrl, 1).subscribe((res: any) => {
      
      if (res.responseCode == 200) {
        this.subCategoryListArray = res.result.subCategory ? res.result.subCategory : '';
        this.totalItems = res.result
        this.commonService.hideSpinner();
        // this.commonService.successToast(res.responseMessage);
      } else {
        this.categoryListArray = []
        this.totalItems = 0
        this.commonService.hideSpinner();
        // this.commonService.errorToast(res.responseMessage)
      }
    })
  }


  getSubCategoryId(id: any) {
    this.subCategoryId = id.target.value
  }






  // ==========================================


  productBySubCategory(id: any) {
    // Clear search query when filtering by subcategory
    this.searchQuery = '';
    localStorage.removeItem('searchQuery');
    // Reset and remember selection
    this.currentPage = 1;
    this.selectedSubCategoryId = id;
    this.selectedCategoryId = undefined;
    
    const apiReqUrl = `product/listProductBySortion`;
    const apiReqData: any = {
      page: String(this.currentPage),
      limit: String(this.itemPerPage),
      userType: 'RETAILER',
      lng: this.longitude || 0,
      lat: this.latitude || 0,
      subCategoryId: [id]
    };
    const cleaned = this.commonService.removeEmptyKey(apiReqData);
    const a = this.commonService.isLoggedIn() ? 1 : 0;
    this.commonService.postApi(apiReqUrl, cleaned, a).subscribe((res: any) => {
      if (res.responseCode == 200) {
        const docs = res.result.docs ? res.result.docs : [];
        this.allProducts = [...docs];
        this.applyFilters(false);
        this.totalItems = res.result.count || res.result.total || docs.length;
        this.commonService.hideSpinner();
      } else {
        this.categoryListArrayNew = [];
        this.totalItems = 0;
        this.commonService.hideSpinner();
      }
    }, (err: any) => {
      this.categoryListArrayNew = [];
      this.totalItems = 0;
      this.commonService.hideSpinner();
    })
  }


  productBySubCategoryId(id: any) {
    this.subCategoryId = id.target.value
  }

  productId: any;

  forID(_id: any) {
    this.router.navigate(['/product-view-customer'], { queryParams: { _id: _id } })
  }

  forEdit(_id: any) {
    this.router.navigate(['/edit-product'], { queryParams: { _id: _id } })
  }


  productDetails: any;
  imgurl: any


// =======================bannerApi=========================
BannerListArray:any

getBannerProductList() {
  let apiReqUrl: any = `user/listBanner`  
  let apiReqData: any = {
    // page: String(this.currentPage),
    limit: String(this.itemPerPage),
  } 
  apiReqData = this.commonService.removeEmptyKey(apiReqData)
  this.commonService.postApi(apiReqUrl, apiReqData, 0).subscribe((res: any) => {
    
    if (res.responseCode == 200) {
      this.BannerListArray = res.result.docs ? res.result.docs : '';
      // this.datalist = res.result.docs[0].thumbnail
      this.totalItems = res.result.total
               
      
      // this.commonService.successToast(res['responseMessage'])
      this.commonService.hideSpinner();
      // this.commonService.successToast(res.responseMessage);
    } else {
      this.BannerListArray = []
      this.totalItems = 0
      this.commonService.hideSpinner();
      // this.router.navigate(['/login'])
      // this.commonService.errorToast(res.responseMessage)
    }
  }, (err: any) => {
    if (err.responseCode == 404) {
      this.BannerListArray = []
      this.totalItems = 0
      // this.router.navigate(['/login'])
      // this.commonService.errorToast(err.responseMessage);

    }else{
      this.router.navigate(['/login'])

    }
  }  )
}

ngOnDestroy() {
  localStorage.removeItem('category');
  localStorage.removeItem('searchQuery');
  // Clear any running image carousel timers
  Object.keys(this.carouselTimerMap).forEach(id => {
    if (this.carouselTimerMap[id]) {
      clearInterval(this.carouselTimerMap[id]);
    }
  });
}
getPrice(e: any) {
  if (e === null || e === undefined) {
    return '';
  }
  const str = String(e);
  const noCommas = str.replace(/,/g, ' ');
  return noCommas.replace(/R/g, 'R ');
}

  // ====== Deal-aware pricing helpers (mirroring customer product list) ======

  private getBasePrice(item: any): number | null {
    if (item?.priceSizeDetails && Array.isArray(item.priceSizeDetails) && item.priceSizeDetails.length > 0) {
      const priceDetail = item.priceSizeDetails[0];
      if (priceDetail?.price && priceDetail.price > 0) {
        return Number(priceDetail.price);
      }
    }

    const priceFields = [
      'price', 'sellingPrice', 'productPrice', 'cost', 'amount',
      'currentPrice', 'salePrice', 'finalPrice', 'unitPrice',
      'pricePerUnit', 'retailPrice', 'wholesalePrice'
    ];

    for (const field of priceFields) {
      if (item?.[field] !== undefined && item[field] !== null && item[field] !== '' && !isNaN(parseFloat(item[field]))) {
        const numPrice = parseFloat(item[field]);
        if (numPrice > 0) {
          return numPrice;
        }
      }
    }

    return null;
  }

  private getDealPrice(item: any): number | null {
    if (item?.dealPrice && item.dealPrice > 0) {
      return Number(item.dealPrice);
    }
    return null;
  }

  // Current price to display (deal price when it exists and is lower than base)
  getDisplayPrice(item: any): string {
    const basePrice = this.getBasePrice(item);
    const dealPrice = this.getDealPrice(item);

    let current: number | null = null;

    if (dealPrice && basePrice && dealPrice < basePrice) {
      current = dealPrice;
    } else if (basePrice) {
      current = basePrice;
    } else if (dealPrice) {
      current = dealPrice;
    }

    if (current !== null) {
      return this.getPrice(current) || String(current);
    }

    return '0';
  }

  // Original price to show with strikethrough (only when there's a lower deal price)
  getOriginalPrice(item: any): string | null {
    const basePrice = this.getBasePrice(item);
    const dealPrice = this.getDealPrice(item);

    if (basePrice && dealPrice && dealPrice < basePrice) {
      return this.getPrice(basePrice) || String(basePrice);
    }

    return null;
  }

  getDiscountPercentage(item: any): number {
    const currentPriceStr = this.getDisplayPrice(item);
    const originalPriceStr = this.getOriginalPrice(item);

    if (!originalPriceStr || currentPriceStr === originalPriceStr) {
      return 0;
    }

    // Strip out any currency symbols or spaces, keep only numbers and decimal
    const currentValue = parseFloat(String(currentPriceStr).replace(/[^0-9.]/g, ''));
    const originalValue = parseFloat(String(originalPriceStr).replace(/[^0-9.]/g, ''));

    if (originalValue <= 0 || currentValue >= originalValue) {
      return 0;
    }

    return Math.floor(((originalValue - currentValue) / originalValue) * 100);
}

  // ===== Image carousel helpers (simple image swap, no slide container) =====

  getImageList(item: any): string[] {
    if (item?.productImage && Array.isArray(item.productImage) && item.productImage.length) {
      return item.productImage;
    }
    if (item?.images && Array.isArray(item.images) && item.images.length) {
      return item.images;
    }
    if (item?.thumbnail) {
      return [item.thumbnail];
    }
    return ['/assets/img/dummy.jpeg'];
  }

  getActiveImage(item: any): string {
    const list = this.getImageList(item);
    const id = item?._id;
    if (!id) {
      return list[0];
    }
    const idx = this.carouselIndexMap[id] ?? 0;
    return list[idx] || list[0];
  }

  getCarouselIndex(item: any): number {
    const id = item?._id;
    if (!id) {
      return 0;
    }
    return this.carouselIndexMap[id] ?? 0;
  }

  startImageCarousel(item: any) {
    const id = item?._id;
    const list = this.getImageList(item);
    if (!id || list.length <= 1) {
      return;
    }

    // Reset index and clear any previous timer
    this.stopImageCarousel(item);
    this.carouselIndexMap[id] = 0;

    this.carouselTimerMap[id] = setInterval(() => {
      const current = this.carouselIndexMap[id] ?? 0;
      this.carouselIndexMap[id] = (current + 1) % list.length;
    }, 1000); // rotate every 1 second on hover
  }

  stopImageCarousel(item: any) {
    const id = item?._id;
    if (!id) {
      return;
    }

    if (this.carouselTimerMap[id]) {
      clearInterval(this.carouselTimerMap[id]);
      delete this.carouselTimerMap[id];
    }
    // Reset back to first image
    this.carouselIndexMap[id] = 0;
  }

  // ===== Filter application =====

  applyFilters(resetPage: boolean = true) {
    let list = this.allProducts ? [...this.allProducts] : [];

    if (this.selectedFilterCategoryId) {
      list = list.filter((item: any) => item?.categoryId?._id === this.selectedFilterCategoryId);
    }

    const cap = this.selectedMaxPrice !== null && this.selectedMaxPrice !== undefined
      ? Number(this.selectedMaxPrice)
      : null;

    // Apply upper bound only when slider is below the max band.
    // When cap >= priceMax (10,000), we intentionally do NOT filter,
    // so 10,000+ products are still included.
    if (cap !== null && !isNaN(cap) && cap < this.priceMax) {
      list = list.filter((item: any) => {
        const basePrice = this.getBasePrice(item);
        const dealPrice = this.getDealPrice(item);
        let current: number | null = null;
        if (dealPrice && basePrice && dealPrice < basePrice) {
          current = dealPrice;
        } else if (basePrice) {
          current = basePrice;
        } else if (dealPrice) {
          current = dealPrice;
        }
        if (current === null) {
          return true;
        }
        return current <= cap;
      });
    }

    if (this.selectedMinDiscount) {
      list = list.filter((item: any) => this.getDiscountPercentage(item) >= (this.selectedMinDiscount as number));
    }

    this.categoryListArrayNew = list;
    if (resetPage) {
      this.currentPage = 1;
    }
  }

  onCategoryFilterChange(categoryId: string) {
    this.selectedFilterCategoryId = categoryId || null;
    this.applyFilters();
  }

  onPriceRangeChange() {
    this.applyFilters(false);
  }

  onDiscountChange() {
    this.applyFilters();
}

// Get all available products without search filter
getAllProducts() {
  let isLoggedIn = localStorage.getItem('token');
  
  if (isLoggedIn) {
    // User is logged in
    if (this.loggedInUserType == 'RETAILER') {
      this.user = 'WHOLE_SALER'
    } else {
      this.user = 'RETAILER'
    }

    let apiReqUrl = `product/listProductBySortion`;
    this.commonService.showSpinner();
    let apiReqData: any = {
      userType: this.user,
      lng: this.longitude || 0,
      lat: this.latitude || 0,
      page: this.currentPage,
      limit: this.itemPerPage
    }
    
    this.commonService.removeEmptyKey(apiReqData);
    this.commonService.postApi(apiReqUrl, apiReqData, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        const docs = res.result.docs ? res.result.docs : [];
        this.allProducts = [...docs];
        this.applyFilters(false);
        if (docs.length > 0 && docs[0]?.thumbnail) {
          this.datalist = docs[0].thumbnail;
        }
        this.totalItems = res.result.count || docs.length;
        this.commonService.hideSpinner();
      } else {
        this.categoryListArrayNew = []
        this.totalItems = 0
        this.commonService.hideSpinner();
      }
    }, (err: any) => {
      this.categoryListArrayNew = []
      this.totalItems = 0
      this.commonService.hideSpinner();
    });
  } else {
    // User is not logged in
    let apiReqUrl = `product/listProductBySortion`;
    this.commonService.showSpinner();
    let apiReqData: any = {
      userType: 'RETAILER',
      lng: this.longitude || 0,
      lat: this.latitude || 0,
      page: this.currentPage,
      limit: this.itemPerPage
    }
    
    this.commonService.removeEmptyKey(apiReqData);
    this.commonService.postApi(apiReqUrl, apiReqData, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        const docs = res.result.docs ? res.result.docs : [];
        this.allProducts = [...docs];
        this.applyFilters(false);
        if (docs.length > 0 && docs[0]?.thumbnail) {
          this.datalist = docs[0].thumbnail;
        }
        this.totalItems = res.result.count || docs.length;
        this.commonService.hideSpinner();
      } else {
        this.categoryListArrayNew = []
        this.totalItems = 0
        this.commonService.hideSpinner();
      }
    }, (err: any) => {
      this.categoryListArrayNew = []
      this.totalItems = 0
      this.commonService.hideSpinner();
    });
  }
}

reset(){
  this.resetToDefaultState();
}

// ===== helpers for search reset =====
resetToDefaultState() {
  this.searchQuery = '';
  this.serviceName = '';
  this.selectedCategoryId = undefined;
  this.selectedSubCategoryId = undefined;
  localStorage.removeItem('searchQuery');
  this.currentPage = 1;
  this.getAllProducts();
}

onSearchInput(value: string) {
  this.searchQuery = value || '';
  this.serviceName = this.searchQuery;
  localStorage.setItem('searchQuery', this.searchQuery);
  this.currentPage = 1;

  if (this.searchQuery.trim()) {
    this.searchProductByName();
  } else {
    this.resetToDefaultState();
  }
}

  // ===== Wishlist handling (mirrors customer product list) =====

  toggleWishlist(productId: string, event: Event) {
    event.stopPropagation();

    if (!this.isLoggedIn) {
      this.commonService.errorToast('Please login to add items to wishlist');
      return;
    }

    const product = this.categoryListArrayNew?.find((p: any) => p._id === productId);
    if (!product) { return; }

    if (product.isLike) {
      this.removeFromWishlist(productId);
    } else {
      this.addToWishlist(productId);
    }
  }

  addToWishlist(productId: string) {
    const apiReqUrl = `${ApiEndPoint.addWishListProduct}?productId=${productId}`;
    this.commonService.showSpinner();

    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      this.commonService.hideSpinner();
      if (res.responseCode === 200) {
        const product = this.categoryListArrayNew?.find((p: any) => p._id === productId);
        if (product) {
          product.isLike = true;
        }
        this.commonService.successToast('Product added to wishlist.');
      } else {
        this.commonService.errorToast(res.responseMessage || 'Failed to add to wishlist');
      }
    }, () => {
      this.commonService.hideSpinner();
      this.commonService.errorToast('Something went wrong');
    });
  }

  removeFromWishlist(productId: string) {
    const apiReqUrl = `${ApiEndPoint.addWishListProduct}?productId=${productId}`;
    this.commonService.showSpinner();

    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      this.commonService.hideSpinner();
      if (res.responseCode === 200) {
        const product = this.categoryListArrayNew?.find((p: any) => p._id === productId);
        if (product) {
          product.isLike = false;
        }
        this.commonService.successToast('Item removed from wishlist');
      } else {
        this.commonService.errorToast(res.responseMessage || 'Failed to remove from wishlist');
      }
    }, () => {
      this.commonService.hideSpinner();
      this.commonService.errorToast('Something went wrong');
    });
}
}

